import React from "react";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import AuthButton from "./AuthButton";
// logo removed from header per request

type Props = {
  onAdminClick?: () => void;
  isAdminOpen?: boolean;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  onContactClick?: (e: React.MouseEvent) => void;
};

const Header = (props: Props) => {
  const COLORS = {
    navy: "#30497A",
    maroon: "#8F1A1E",
    gold: "#C08D12",
    black: "#000000",
    white: "#FFFFFF",
  } as const;

  const toolbarStyle: React.CSSProperties = {
    width: "100%",
    boxSizing: "border-box",
    padding: "16px clamp(16px, 4vw, 48px)",
    background: COLORS.white,
    color: COLORS.black,
    borderBottom: `8px solid ${COLORS.black}`,
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    boxShadow: "none",
  };

  const start = () => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            fontWeight: 800,
            letterSpacing: 1,
            textTransform: "uppercase",
          }}
        >
          <img src="header-logo.png" alt="Seeward logo" className="header-logo" />
          {/* brand text removed as requested */}
          <span
            className="brand-dot"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 36,
              height: 36,
            }}
          >
            <svg viewBox="0 0 24 24" width="36" height="36" aria-hidden="true">
              <polygon
                points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"
                fill="#FF0000"
                stroke="#000000"
                strokeWidth="2"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span
            className="brand-dot"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 24,
            }}
          >
            <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
              <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9" fill="#000000" />
            </svg>
          </span>
          <span
            className="brand-dot"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 16,
              height: 16,
            }}
          >
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <polygon
                points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"
                fill="#FF0000"
                stroke="#000000"
                strokeWidth="2"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
    );
  };

  const end = () => {
    return (
      <nav style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span>
          <InputText
            placeholder="Search"
            value={props.searchValue ?? ""}
            onChange={(e) => props.onSearchChange?.(e.currentTarget.value)}
            style={{
              width: "min(22ch, 60vw)",
              border: `3px solid ${COLORS.black}`,
              boxShadow: `4px 4px 0 ${COLORS.black}`,
              padding: "10px 12px",
            }}
          />
        </span>
        <a
          href="#contact"
          className="nav-link"
          aria-label="Contact"
          title="Contact"
          onClick={(e) => props.onContactClick?.(e)}
          style={{
            background: COLORS.gold,
            color: COLORS.black,
            borderColor: COLORS.black,
          }}
        >
          <svg
            className="icon"
            viewBox="0 0 24 24"
            width="22"
            height="22"
            aria-hidden="true"
          >
            <rect x="3" y="5" width="18" height="14" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="2" />
            <path d="M3 7l9 6 9-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
        <AuthButton />
      </nav>
    );
  };

  return (
    <>
      <Toolbar start={start} end={end} className="brutalist-header" style={toolbarStyle} />
      <style>
        {`
          /* Ensure sticky works across browsers */
          .brutalist-header {
            position: sticky;
            position: -webkit-sticky;
            top: 0;
          }
          .brutalist-header .p-toolbar-group-left,
          .brutalist-header .p-toolbar-group-right {
            gap: 12px;
          }

          /* Ensure header calculates width including padding */
          .brutalist-header {
            box-sizing: border-box;
          }

          .brutalist-header .header-logo {
            width: 84px;
            height: 84px;
       
            background: #ffffff;
         
            display: inline-block;
          }

          .brutalist-header .nav-link {
            text-decoration: none;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            padding: 12px 16px;
            border: 3px solid;
            box-shadow: 4px 4px 0 #000;
            transition: transform 80ms ease-out, box-shadow 80ms ease-out;
          }

          .brutalist-header .nav-link:hover {
            transform: translate(-2px, -2px);
            box-shadow: 6px 6px 0 #000;
          }

          .brutalist-header .nav-outline {
            background: #ffffff;
          }

          .brutalist-header .nav-link .icon {
            display: block;
          }

          /* Mobile: hide brand text and three dots */
          @media (max-width: 760px) {
            /* Keep header within viewport to avoid overflow */
            .brutalist-header { width: 100%; margin: 0; }
            .brutalist-header .brand-text,
            .brutalist-header .brand-dot { display: none !important; }
          }
        `}
      </style>
    </>
  );
};

export default Header;
